module.exports = __webpack_public_path__ + "img/society-anning-avatar.d0371519.png";